export const IS_WAITING = 'IS_WAITING';
export const IS_OPEN = 'IS_OPEN';
export const SPORTS = 'SPORTS';
export const IS_LOGIN = 'IS_LOGIN';
export const CONTACT_US = 'CONTACT_US';

export const onWaiting = (is_waiting) => ({
    type: IS_WAITING,
    is_waiting
})


export const getMyUsers = () => {
    try {
        return JSON.parse(sessionStorage.getItem('myusers'))
    } catch(error) {
        return [];
    }
}

const onGetSports = (data) => ({
    type: SPORTS,
    data
})

export const openTopnav = (is_open) => ({
    type: IS_OPEN,
    is_open
})

export const getSports = () => {
    return (dispatch, getState, { api }) => {
        api.get('/sportslists')
            .then(response => {
                const { data } = response;
                dispatch(onGetSports(data))
            })
    }
}

export const onLoggedIn = (isLoggedIn) => ({
    type: IS_LOGIN,
    isLoggedIn
})

export const isLogin = () => {
    return (dispatch, getState, { token }) => {
        const isLoggedIn = token.validate(sessionStorage.getItem('token'));
        dispatch(onLoggedIn(isLoggedIn));
    }
}

export const onContactUs = (reset) => ({
    type: CONTACT_US,
    reset
})

export const contactUs = (params) => {
    return (dispatch, getState, { api, alert }) => {
        dispatch(onWaiting(true));
        api.post('/contact', params, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return false;
                dispatch(onContactUs(true));
                alert.success('Your message has been successfully sent!');
            })
    }
}

/* eslint-disable */
export const getFirstMessage = (data) => {
    let firstMessage = '';
    let x = 0;
    
    Object.keys(data).map(i => {
        if(x===0){
            firstMessage = data[i];
        }
        x++;
    });
    return firstMessage; 
}


// WEBPACK FOOTER //
// ./src/Actions.js